import { useEffect } from "react";

export function useSaveBeforeUnload(pending: boolean | (() => boolean)) {
  useEffect(() => {
    if (!pending) return;
    const beforeUnload = (event: BeforeUnloadEvent) => {
      if (typeof pending === "function" && !pending()) return;
      event.preventDefault();
      event.returnValue = "";
    };
    window.addEventListener("beforeunload", beforeUnload);
    return () => window.removeEventListener("beforeunload", beforeUnload);
  }, [pending]);
}
